import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import { useSelector } from "react-redux";

const matchPathWithParams = (patternPath, actualPath) => {
  const regexPattern = patternPath
    .replace(/:[^/]+/g, "[^/]+")
    .replace(/\//g, "\\/");

  const regex = new RegExp(`^/admin${regexPattern}`);
  return regex.test(actualPath);
};

const usePermissions = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const { user, userPermissions } = useSelector((state) => state.auth);
  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get("tab");

  const matchedPermission = useMemo(() => {
    if (user?.type === "restaurant") {
      return {
        add: true,
        get: true,
        edit: true,
        delete: true,
        export: true,
        import: true,
        visibility: true,
        duplicate: true,
      };
    }

    for (const key in userPermissions) {
      const permission = userPermissions[key];

      if (key === "menus") {
        if (tab === "addOns" && permission?.addOns?.active) {
          return permission.addOns.options;
        }
        if (tab === "labels" && permission?.label?.active) {
          return permission.label.options;
        }

        const category = permission?.category;
        if (category?.active) {
          const items = category.items;
          if (items?.active && matchPathWithParams(items.path, currentPath)) {
            return items.options;
          }

          if (matchPathWithParams(category.path, currentPath)) {
            return category.options;
          }
        }

        if (
          permission?.active &&
          currentPath.startsWith(`/admin${permission.path}`)
        ) {
          return permission.options;
        }
      }

      if (
        permission?.active &&
        currentPath.startsWith(`/admin${permission.path}`)
      ) {
        return permission.options;
      }
    }

    return {};
  }, [userPermissions, currentPath, user?.type, tab]);

  return matchedPermission;
};

export default usePermissions;
